/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageConsumptionReportDto } from '../../models/page-consumption-report-dto';

export interface GetConsumptionReports$Params {
  companyId: string;
  reportMonth: string;
  page: number;
  size: number;
}

export function getConsumptionReports(http: HttpClient, rootUrl: string, params: GetConsumptionReports$Params, context?: HttpContext): Observable<StrictHttpResponse<PageConsumptionReportDto>> {
  const rb = new RequestBuilder(rootUrl, getConsumptionReports.PATH, 'get');
  if (params) {
    rb.query('companyId', params.companyId, {});
    rb.query('reportMonth', params.reportMonth, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageConsumptionReportDto>;
    })
  );
}

getConsumptionReports.PATH = '/v1/api/admin-ui/company/consumption-reports';
